import React from 'react';

const globalMatrixContextsKeyName = '__MatrixContexts__';

export const getOrCreateGlobalContext = name => {
  if (!window[globalMatrixContextsKeyName]) {
    window[globalMatrixContextsKeyName] = {};
  }
  if (!window[globalMatrixContextsKeyName][name]) {
    window[globalMatrixContextsKeyName][name] = React.createContext();
  }
  return window[globalMatrixContextsKeyName][name];
};

export const CONTEXT_NAMES = {
  AccountContext: 'AccountContext',
  CurrentUserContext: 'CurrentUserContext',
  EnvContext: 'EnvContext',
  MatrixLaunchDarklyContext: 'MatrixLaunchDarklyContext',
  ProjectContext: 'ProjectContext',
  NotificationContext: 'NotificationContext',
  TokenContext: 'TokenContext',
  IdleTimeContext: 'IdleTimeContext',
  Theme: 'Theme'
};
